import React from 'react';
import { isNavigable, PeriodType } from './periodModel';

export interface PeriodOption {
  label: string;
  value: PeriodType;
}

interface PeriodPillsProps {
  periods: PeriodOption[];
  selected: PeriodType;
  resolvedLabel: string;
  open: boolean;
  onSelect: (value: PeriodType) => void;
  onToggle: () => void;
  triggerRef: React.RefObject<HTMLButtonElement>;
  children?: React.ReactNode;
}

export default function PeriodPills({
  periods,
  selected,
  resolvedLabel,
  open,
  onSelect,
  onToggle,
  triggerRef,
  children,
}: PeriodPillsProps): React.ReactElement {
  return (
    <div className="dr-pills" role="radiogroup" aria-label="Date range period">
      {periods.map(({ label, value }) => {
        const isSelected = value === selected;
        const isTrigger = isSelected && isNavigable(value);

        const pill = (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={isSelected}
            ref={isTrigger ? triggerRef : undefined}
            className={`dr-pill${isSelected ? ' is-selected' : ''}${isTrigger ? ' is-trigger' : ''}`}
            onClick={() => (isTrigger ? onToggle() : onSelect(value))}
            {...(isTrigger
              ? { 'aria-haspopup': 'dialog' as const, 'aria-expanded': open }
              : undefined)}
          >
            {isTrigger ? resolvedLabel : label}
            {isTrigger && (
              <i
                className={`fa-solid fa-chevron-down dr-chevron${open ? ' is-open' : ''}`}
                aria-hidden="true"
              />
            )}
          </button>
        );

        return isTrigger ? (
          <div className="dr-pill-wrap" key={value}>
            {pill}
            {children}
          </div>
        ) : (
          pill
        );
      })}
    </div>
  );
}
